import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputAutofocusDirective } from '../../directives/mat-input-autofocus.directive';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { A11yModule } from '@angular/cdk/a11y';
import { AuthDropboxProviderModule } from '../../../features/auth-dropbox/auth-dropbox.provider.module';
import { AuthGoogleProviderModule } from '../../../features/auth-google/auth-google.provider.module';
import { AuthMicrosoftProviderModule } from '../../../features/auth-microsoft/auth-microsoft.provider.module';
import { AuthZohoProviderModule } from '../../../features/auth-zoho/auth-zoho.provider.module';
import { AuthProviderModule } from '../../../features/auth/auth.provider.module';
import { CommonProviderModule } from '../../../features/common/common.provider.module';
import { PurchasesProviderModule } from '../../../features/purchases/purchases.provider.module';
import { TeamProviderModule } from '../../../features/team/team.provider.module';
import { DialogService } from './services/dialog.service';
import { NavigationService } from './services/navigation.service';
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { SessionExpiredDialogComponent } from './components/session-expired-dialog/session-expired-dialog.component';
import { AlbumsProviderModule } from '../../../features/albums/albums.provider.module';
import { FeedProviderModule } from '../../../features/feed/feed.provider.module';
import { GalleriesProviderModule } from '../../../features/galleries/galleries.provider.module';
import { IndustryProviderModule } from '../../../features/industries/industry.provider.module';
import { WaitDialogComponent } from 'src/app/features/shared/components/wait-dialog/wait-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { TipsService } from './services/tips.service';
import { GoogleMapsService } from './services/google-maps.service';
import { SearchAddressComponent } from './components/search-address/search-address.component';
import { UpgradeScopesDialogComponent } from './components/upgrade-scopes-dialog/upgrade-scopes-dialog.component';
import { WithFlavorPipe } from '../../pipes/with-flavor.pipe';
import { OperationLogsProviderModule } from '../../../features/operation-logs/operation-logs.provider.module';

const DECLARATIONS = [
  AlertDialogComponent,
  ConfirmDialogComponent,
  SessionExpiredDialogComponent,
  SearchAddressComponent,
  WaitDialogComponent,
  UpgradeScopesDialogComponent,
];

const MODULES = [
  A11yModule,
  AlbumsProviderModule,
  AuthDropboxProviderModule,
  AuthGoogleProviderModule,
  AuthMicrosoftProviderModule,
  AuthZohoProviderModule,
  AuthProviderModule,
  CommonModule,
  CommonProviderModule,
  FeedProviderModule,
  GalleriesProviderModule,
  IndustryProviderModule,
  MatAutocompleteModule,
  MatButtonModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputAutofocusDirective,
  MatInputModule,
  MatMenuModule,
  MatNativeDateModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule,
  MatSnackBarModule,
  MatTooltipModule,
  OperationLogsProviderModule,
  PurchasesProviderModule,
  ReactiveFormsModule,
  TeamProviderModule,
  TranslateModule,
  WithFlavorPipe,
];

@NgModule({
  imports: MODULES,
  declarations: DECLARATIONS,
  providers: [DialogService, GoogleMapsService, NavigationService, TipsService],
  exports: [...MODULES, ...DECLARATIONS],
})
export class SharedModule {}
